<template>
  <div id="supperson">
    <span class="supperTitle">账户管理</span>
    <el-row>
      <el-col :span="5" class="leftTree">
        <personLeft
          @getLeftClickData="getLeftClickData"
          @getLeftAllData="getLeftAllData"
          @exportSuccess="exportSuccess"
          :key="refreshKey"
        ></personLeft>
      </el-col>
      <el-col :span="18" class="rightTable">
        <personRight ref="rightModel" :giveRightData="leftData"></personRight>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import personLeft from "@/views/supperson/components/left/index.vue";
import personRight from "@/views/supperson/components/right/index.vue";
export default {
  components: {
    personLeft,
    personRight,
  },
  data() {
    return {
      leftData: [],
      giveRightData: [],
      refreshKey: 0
    };
  },
  created() {},
  mounted() {},
  methods: {
    getLeftClickData(params) {
      this.$refs.rightModel.init(params);
    },
    getLeftAllData(val) {
      this.$refs.rightModel.getLeftAllData(val);
    },
    exportSuccess() {
      this.refreshKey = (this.refreshKey + 1) % 2
    }
  },
};
</script>

<style scoped lang="scss">
#supperson {
  height: 100%;
  .supperTitle {
    width: 100%;
    height: 56px;
    line-height: 56px;
    font-size: 16px;
    font-weight: 600;
    padding-left: 12px;
    display: inline-block;
    border-bottom: 1px solid #e5e8f1;
    color: #333333;
  }
  .leftTree {
    height: 100%;
    padding: 12px;
    border-right: 1px solid #e5e8f1;
  }
  .el-row {
    height: calc(100% - 56px);
    .leftTable {
      height: 100%;
    }
    .rightTable {
      height: 100%;
    }
  }
}
</style>
